import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { createSupplierContactSchema } from '../../../contacts/validators/schemas/create-supplier-contact.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { SupplierTypeEnum } from '../../enums/supplier-type.enum';

/**
 * Schema for new supplier record validation.
 */
export const createSupplierSchema = () =>
  Joi.object({
    // Type
    type: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|supplier-type|cannot-be-null',
        }),
        otherwise: Joi.string()
          .valid(...Object.values(SupplierTypeEnum))
          .required()
          .messages({
            'any.required': 'validations|supplier-type|required',
            'any.only': 'validations|supplier-type|invalid-value',
          }),
      })
      .required()
      .messages({
        'any.required': 'validations|supplier-type|required',
      })
      .prefs({ abortEarly: true }),

    // Contact
    contact: createSupplierContactSchema(),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|supplier-notes|must-be-string',
    }),

    // Tags
    tags: createTagsSchema().messages({
      'array.base': 'validations|supplier-tags|invalid-value',
    }),

    policies: createPoliciesAssignSchema(AppSubjectEnum.SUPPLIER),

    files: Joi.any().allow(null),
  })
    // Ignore extra fields
    .unknown();
